enum ReservationRequestStatus {
  Submitted = 'submitted',
  Processing = 'processing',
  Confirmed = 'confirmed',
  Rejected = 'rejected',
}

export default ReservationRequestStatus;
